import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useEffect, useState } from 'react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import { connect } from 'react-redux'
import { updateModal } from '../../../../../store/common/common_action'
import * as mdt from '../../../../common/modaltypes'
import ExpenseHeadsModal from '../ExpenseHeadsModal'
import { useAtom } from 'jotai'
import { ExpenseHeadDetailsData, ExpenseSubHeadDetailsData, fetchExpenseHeadDetails, fetchExpenseSubHeadDetails } from '../../../../common/jotaiState/expenseHead'
import { activeInactive } from '../ExpenseHeads/ExpenseHeads'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
const ExpenseSubHeads = (props) => {
  const { data, updateModal, selectedTab, } = props
  const { common } = data
  const { loginData, showModal, modalType } = common
  const [editdata, setEditdata] = useState()
  const [isUpdate, setIsUpdate] = useState(false)
  const [filterValues, setFilterValues] = useState({})
  const [expenseSubHeadDetailsTableData] = useAtom(ExpenseSubHeadDetailsData)
  const [, fetchExpenseSubHead] = useAtom(fetchExpenseSubHeadDetails)
  const [expenseHeadDetailsTableData] = useAtom(ExpenseHeadDetailsData)
  const [, fetchExpenseHead] = useAtom(fetchExpenseHeadDetails)

  const columnDefs = [
    {
      headerName: 'SN',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '2%' },
      field: 'SN',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: 'ACCOUNT SUB HEAD',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '5%' },
      field: 'SubHeadName',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: 'ACCOUNT HEAD',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '12%' },
      field: 'AccountHead',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },

    {
      headerName: 'ACTIVE',
      headerSx: { padding: '6px 12px', textAlign: 'center', minWidth: '9%' },
      field: 'Active',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: 'Edit',
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '4%' },
      field: 'Edit',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
  ]
  const [filteredData, setfilteredData] = useState([])
  const [isActive,setIsActive] = useState(activeInactive[0])
  useEffect(() => {
    const data = expenseSubHeadDetailsTableData?.map((item, index) => ({ ...item, SN: index + 1, AccountHead: item.HeadName, AccountSubHead: item.SubHeadName, Active: item.IsActive, isEdited: false, Edit: 'edit', isDataRow: 'true' }))
    setfilteredData(data)
  }, [expenseSubHeadDetailsTableData])
  const fetchTableDataForHead = async () => {
    try {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intAccountHeadID: 0,
        intIsActive: -1,
      };

      await fetchExpenseHead(obj);
    } catch (error) {
      console.error("Error fetching expense head:", error);
    }
  };
  useEffect(() => {
      fetchTableDataForHead();
  }, [loginData?.intCompanyID,selectedTab]);
  const fetchTableData = async () => {
    try {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intAccountHeadID: 0,
        intAccountSubHeadID: 0,
        intIsActive: -1,
      };

      await fetchExpenseSubHead(obj);
    } catch (error) {
      console.error("Error fetching expense sub head:", error);
    }
  };
  useEffect(() => {
      fetchTableData();
  }, [loginData?.intCompanyID,selectedTab]);
  useEffect(() => {
    if (!expenseSubHeadDetailsTableData) return
    const allData = expenseSubHeadDetailsTableData.map((item, index) => ({
      ...item,
      SN: index + 1,
      AccountHead: item.HeadName,
      AccountSubHead: item.SubHeadName,
      Active: item.IsActive,
      isEdited: false,
      Edit: 'edit',
      isDataRow: 'true',
    }))
    let filtered = allData.filter((row) => {
      return columnDefs.every((col) => {
        const filterVal = filterValues[col.field] || ''
        if (!filterVal) return true
        const cellValue = row[col.field] ?? ''
        return cellValue.toString().toLowerCase().includes(filterVal.toLowerCase())
      })
    })
    if (isActive.value !== -1) {
      filtered = filtered.filter((row) => row.Active === isActive.value)
    }
    setfilteredData(filtered)
  }, [filterValues, expenseSubHeadDetailsTableData, isActive])
  const handleChangeContain = (e, name) => {
    let value = e.target.value
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value,
    }))
  }
  const handleSave = (formData) => {
    if (isUpdate) {
      const updatedData = filteredData.map((item) =>
        item.isEdited
          ? {
            ...item,
            AccountHead: formData?.AccountHead,
            AccountSubHead: formData?.AccountSubHead,
            isEdited: false,
          }
          : item
      )
      setfilteredData(updatedData)
    } else {
      setfilteredData([
        ...filteredData,
        {
          SN: filteredData.length + 1,
          AccountHead: formData?.AccountHead,
          AccountSubHead: formData?.AccountSubHead,
          isEdited: false,
          Edit: 'edit',
          isDataRow: 'true',
          Active: 'checkbox',
        },
      ])
    }

  }
  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={12}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>No results found for the selected filters.</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }
  const handleEditClick = (clickedItem) => {
    const updatedData = filteredData.map((item) =>
      item.SN === clickedItem.SN ? { ...item, isEdited: true } : item);
    setfilteredData(updatedData);
    setEditdata(clickedItem)
    setIsUpdate(true)
    updateModal(true, mdt.expenseSubHead)
  }
  const InsideRowContent = (props) => {
    const { item, index } = props
    return (
      <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '40px' }}>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '2%', padding: '4px 12px', textAlign: 'left' }}>
          {index + 1}
        </TableCell>

        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '5%', padding: '4px 12px', textAlign: 'left' }}>
          {item.AccountSubHead}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '9%', padding: '4px 12px', textAlign: 'left' }}>
          {item.AccountHead}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '5%', padding: '4px 12px', textAlign: 'center' }}>
          {item.Active ? (
            <span>
              <CheckMarkSvg />
            </span>
          ) : (
            <span>
              <XMarkSvg />
            </span>
          )}
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '4%', padding: '4px 12px' }}>
          <span
            id={`editBtn-${index}`}
            tabIndex={0}
            style={{
              display: 'flex',
              color: '#007bfd',
              fontSize: '13px',
              fontWeight: 'bold',
              width: '52px',
              padding: '2px 4px',
              marginLeft: '-6px',
            }}
            onClick={() => {
              handleEditClick(item)
            }}
          >
            <EditIcon sx={{ marginRight: '3px' }} />
            Edit
          </span>
        </TableCell>
      </TableRow>
    )
  }
  return (
    <>
      <Stack style={{ padding: '5px 0px',flexDirection:'row',gap:'10px' }}>
        <Item sx={{ ...sx.itemsx }}>
          <DropDownOA
            label="Active / Inactive"
            idKey="value"
            dataKey="label"
            data={activeInactive}
            defaultvalue={isActive.label}
            onSelect={(val) => {
              setIsActive(val)
            }}
          />
        </Item>
        <Button
          id="mopAddBtn"
          style={{ margin: '0', height: '40px', width: '150px' }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={() => {
            setIsUpdate(false)
            updateModal(true, mdt.expenseSubHead)
          }}
        >
          add new
        </Button>
      </Stack>
      <Stack style={{ maxHeight: '60vh', marginTop: '7px' }}>
        <TableContainer
          className="lr-popup-table lrModel  scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="focApprovalTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff' }}>
                {columnDefs.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {col.headerName.split('\n').map((line, lineIndex) => (
                        <span key={`line-${lineIndex}`} style={{}}>
                          {line}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {columnDefs.map((col, index) =>
                  col.showfilter ? (
                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                      <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                        <input
                          id={`index-${index}`}
                          className="field"
                          name="cancelSearchInput"
                          style={{ width: '100%', height: '24px' }}
                          placeholder="Contains"
                          onChange={(e) => handleChangeContain(e, col.field)}
                        // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? `Edit-${showTableData?.length - 1}` : `index-${index - 1}`, index === 10 ? 'Edit-0' : `index-${index + 1}`)}
                        />
                        <FilterAltIcon style={{ color: '#aaa' }} />
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell></TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            {filteredData?.length > 0 ? (
              <>
                <TableBody className="filter-data-row" style={{ border: 'none' }}>
                  {filteredData?.map((item, index) => (
                    <InsideRowContent item={item} index={index} key={index} />
                  ))}
                </TableBody>
              </>
            ) : (
              <>
                <TableBody>
                  <EmptyTableRow />
                </TableBody>
              </>
            )}
          </Table>
        </TableContainer>
      </Stack>
      {showModal && mdt.expenseHead === modalType ? (
        ''
      ) : null}
      {showModal && mdt.expenseSubHead === modalType ? (
        <ExpenseHeadsModal
          updateModal={updateModal}
          headTxt={isUpdate ? 'EDIT SUB ACCOUNT HEAD' : 'ADD SUB ACCOUNT HEAD'}
          isUpdate={isUpdate}
          editData={editdata}
          loginData={loginData}
          selectedTab={selectedTab}
          handleSave={handleSave}
          fetchTableData={fetchTableData}
          expenseHeadDetailsTableData={expenseHeadDetailsTableData}
        />
      ) : null}
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(ExpenseSubHeads)
